import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTellentLogoComponent } from '../../components/email-tellent-logo/email-tellent-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { TellentProductsFooterComponent } from '../../components/tellent-products-footer/tellent-products-footer.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  styleUrls: ['../../global-styles.less', './tellent-account-recovery.component.less'],
  templateUrl: './tellent-account-recovery.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailTellentLogoComponent,
    TellentProductsFooterComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class TellentAccountRecoveryTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<TellentAccountRecoveryTemplateData>;
}

export type TellentAccountRecoveryTemplateData = {
  header: string;
  subheader: string;
  body: string;
  primary_cta: {
    href: string;
    label: string;
  };
  footer: {
    text: string;
    label: string;
    href: string;
  };
  message_html: string;
};

export const TellentAccountRecoveryTemplateMocks: TellentAccountRecoveryTemplateData[] = [
  {
    header: 'Recover access to your account',
    subheader: 'You can now recover access to your account with the link below.',
    body: 'Please note that once you log in, the 2FA feature will be disabled. You can set it up again in settings.',
    primary_cta: {
      href: 'http://recruitee.com',
      label: 'Recover access',
    },
    footer: {
      text: 'Need help?',
      href: 'support@tellent.com',
      label: 'Contact us',
    },
    message_html:
      "On %{date} we've received a request to recover access to your account after losing a two-factor authentication device. If it wasn't you, please <a href='%{url}'>contact our support</a>.",
  },
];
